import { openLoginModal, openRegistrationModal } from '~~/common/composables/useLoginModal';

export default {
  methods: {
    openLoginModal,
    openRegistrationModal,
  },
};
